import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Box, Grid } from "@mui/material";
export const ImageSized = ({ maxWidth, maxHeight, src, alt, onClick, ...props }) => {
    const [style, setStyle] = useState({ maxWidth, maxHeight });
    return (_jsx(Box, { sx: { maxWidth, maxHeight }, children: _jsx(Box
        // @ts-ignore
        , { 
            // @ts-ignore
            onLoad: ({ target }) => {
                const size = { x: target.naturalWidth, y: target.naturalHeight };
                // tslint:disable-next-line:no-shadowed-variable
                const style = { maxWidth: size.x, maxHeight: size.y };
                if (style.maxWidth > maxWidth) {
                    style.maxWidth = maxWidth;
                    style.maxHeight = maxWidth * (size.y / size.x);
                }
                if (style.maxHeight > maxHeight) {
                    style.maxHeight = maxHeight;
                    style.maxWidth = maxHeight * (size.x / size.y);
                }
                setStyle(style);
            }, component: 'img', sx: {
                cursor: onClick ? 'pointer' : undefined,
                width: '100%',
                height: 'auto',
                ...style,
            }, src: src, alt: alt, onClick: onClick, ...props }, void 0) }, void 0));
};
export const Image = (props) => {
    return (_jsx(Grid, { container: true, justifyContent: 'center', alignContent: 'center', alignItems: 'center', children: _jsx(ImageSized, { ...props }, void 0) }, void 0));
};
//# sourceMappingURL=Image.js.map